function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useContext } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import { cmsActions } from '../../../reducers/cms.reducer';
import { history } from '../../../store/store';
import ArticlesEditData from './ArticlesEditData.context';
import UploadImage from '../../common/assets/UploadImage.modal';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Label from '../../common/form/Label.react';
import Input from '../../common/form/Input.react';
import Button from '../../common/Button.react';
import AzureBlob from '../../common/AzureBlob.react';
import SlotModal from '../../common/modal/Slot.modal';
var ArticleImages = function ArticleImages(_ref) {
  var addModalAction = _ref.addModalAction,
    removeModalAction = _ref.removeModalAction,
    articleAssetAction = _ref.articleAssetAction,
    articlesAction = _ref.articlesAction;
  var navigate = useNavigate();
  var _useContext = useContext(ArticlesEditData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var articleID = state.articleID,
    articleType = state.articleType,
    slideshow = state.slideshow,
    archived = state.archived;
  if (articleType !== 'product') return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Slideshow Images",
    button: {
      label: 'Add Image',
      type: 'add',
      permission: 'edit-pos-articles',
      disabled: archived,
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(UploadImage, {
            disableSelectImageType: true,
            onUploaded: function onUploaded(img) {
              articleAssetAction({
                formData: {
                  type: 'slideshow',
                  articleID: articleID,
                  assetID: img._id
                }
              });
              removeModalAction();
            }
          })
        });
      }
    }
  }), /*#__PURE__*/React.createElement(CardBody, null, (slideshow === null || slideshow === void 0 ? void 0 : slideshow.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, slideshow.sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      className: "a-slideshow ".concat(selected && selected._id === x._id ? 'a-slideshow__selected' : ''),
      onClick: function onClick() {
        return setSelected((selected === null || selected === void 0 ? void 0 : selected._id) !== x._id ? x : null);
      },
      key: x._id
    }, /*#__PURE__*/React.createElement(AzureBlob, {
      filename: x.filename,
      className: "a-slideshow__img--lowres"
    }));
  })), selected && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "a-img__img"
  }, /*#__PURE__*/React.createElement(Label, {
    label: "Title"
  }), /*#__PURE__*/React.createElement(Input, {
    value: selected === null || selected === void 0 ? void 0 : selected.title,
    onChange: function onChange(e) {
      setSelected(_objectSpread(_objectSpread({}, selected), {}, {
        title: e.target.value
      }));
    },
    permission: "edit-pos-articles"
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Subtitle"
  }), /*#__PURE__*/React.createElement(Input, {
    value: selected === null || selected === void 0 ? void 0 : selected.subtitle,
    onChange: function onChange(e) {
      setSelected(_objectSpread(_objectSpread({}, selected), {}, {
        subtitle: e.target.value
      }));
    },
    permission: "edit-pos-articles"
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Alt Tag"
  }), /*#__PURE__*/React.createElement(Input, {
    value: selected === null || selected === void 0 ? void 0 : selected.altTag,
    onChange: function onChange(e) {
      setSelected(_objectSpread(_objectSpread({}, selected), {}, {
        altTag: e.target.value
      }));
    },
    permission: "edit-pos-articles"
  })), !archived && /*#__PURE__*/React.createElement("div", {
    className: "a-img__controls"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Re-Arrange",
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(SlotModal, {
          items: slideshow.sort(function (a, b) {
            return a.slot - b.slot;
          }).map(function (x) {
            return {
              id: x._id,
              filename: x.filename
            };
          }),
          type: "images",
          route: "pos-article-slideshow",
          formData: {
            articleID: articleID
          }
        })
      });
    },
    disabled: (slideshow === null || slideshow === void 0 ? void 0 : slideshow.length) <= 1
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    type: "delete",
    requireConfirmation: true,
    icon: "lock-icon@3x.png",
    permission: "edit-pos-articles",
    onClick: function onClick() {
      articleAssetAction({
        formData: {
          assetID: selected._id,
          type: 'slideshow',
          articleID: articleID
        },
        method: 'delete'
      });
      setSelected(null);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "View Asset",
    onClick: function onClick() {
      return navigate("/asset/".concat(selected === null || selected === void 0 ? void 0 : selected.assetID));
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Update",
    permission: "edit-pos-articles",
    onClick: function onClick() {
      articlesAction({
        formData: {
          articleID: articleID,
          assetID: selected._id,
          title: selected.title,
          subtitle: selected.subtitle,
          altTag: selected.altTag
        },
        method: 'put',
        route: 'slideshow'
      });
      setSelected(null);
    }
  }))))));
};
var mdtp = {
  addModalAction: modalActions.add,
  removeModalAction: modalActions.remove,
  articleAssetAction: cmsActions.articleAsset,
  articlesAction: cmsActions.articles
};
export default connect(null, mdtp)(ArticleImages);